// DashboardColorContext.tsx
import { createContext, useContext } from "react";

export const DashboardColorContext = createContext<string>("#21506F");

export const useDashboardColor = () => useContext(DashboardColorContext);
